export default "__VITE_ASSET__BLFLo5Ep__"